import { api } from '../../../../lib/api';

export const laborAbsenceService = {
  /**
   * GET /api/labor/absences?factory_id=&employee_id=&status=&from=&to=
   */
  async listAbsences({ factoryId = null, employeeId = null, status = '', from = null, to = null } = {}) {
    const params = new URLSearchParams();
    if (factoryId) params.set('factory_id', String(factoryId));
    if (employeeId) params.set('employee_id', String(employeeId));
    if (status) params.set('status', status);
    if (from) params.set('from', from);
    if (to) params.set('to', to);
    const qs = params.toString();
    const data = await api.get(`/api/labor/absences${qs ? `?${qs}` : ''}`);
    return Array.isArray(data) ? data : [];
  },

  /** GET /api/labor/absences/:id */
  async getAbsence(id) {
    return api.get(`/api/labor/absences/${id}`);
  },

  /** POST /api/labor/absences */
  async createAbsence({ employeeId, absenceType, startDate, endDate, reason = '' }) {
    return api.post('/api/labor/absences', {
      employee_id: Number(employeeId),
      absence_type: absenceType,
      start_date: startDate,
      end_date: endDate,
      reason: String(reason).trim(),
    });
  },

  /** PUT /api/labor/absences/:id */
  async updateAbsence(id, { absenceType, startDate, endDate, reason = '' }) {
    return api.put(`/api/labor/absences/${id}`, {
      absence_type: absenceType,
      start_date: startDate,
      end_date: endDate,
      reason: String(reason).trim(),
    });
  },

  /** DELETE /api/labor/absences/:id */
  async deleteAbsence(id) {
    return api.delete(`/api/labor/absences/${id}`);
  },

  /** POST /api/labor/absences/:id/approve */
  async approveAbsence(id, approvedBy) {
    return api.post(`/api/labor/absences/${id}/approve`, {
      approved_by: Number(approvedBy),
    });
  },

  /** POST /api/labor/absences/:id/reject */
  async rejectAbsence(id, reason = '') {
    return api.post(`/api/labor/absences/${id}/reject`, {
      reason: String(reason).trim(),
    });
  },

  /** POST /api/labor/absences/:id/cancel */
  async cancelAbsence(id) {
    return api.post(`/api/labor/absences/${id}/cancel`, {});
  },
};
